import { MsalProvider } from "@azure/msal-react";
import { Fragment } from "react";
import "./App.css";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { BrowserRouter } from "react-router-dom";
import RoutesComponent from "RoutesComponent";
import { store, StoreContext } from "./core/stores/index";
import { SnackbarProvider } from "notistack";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import { PublicClientApplication } from "@azure/msal-browser";
import Fade from "@mui/material/Fade";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Decimal from "decimal.js";

interface AppProps {
    msalInstance: PublicClientApplication;
}

function App(props: AppProps) {   
    Decimal.set({
        precision: 2,
    });
    return (
        <>
            {/* <AppInsights />
    <AppInsightsContext.Provider value={reactPlugin}>
                <AppInsightsErrorBoundary onError={() => <h1>Something went wrong. Please contact admin if its recurring.</h1>} appInsights={reactPlugin}> */}
            {props.msalInstance && (
            <SnackbarProvider maxSnack={4} anchorOrigin={{ horizontal: "left", vertical: "bottom" }} TransitionComponent={Fade}>
                <StoreContext.Provider value={store}>
                    <Fragment>
                        <BrowserRouter basename={"/"}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MsalProvider instance={props.msalInstance}>
                                    <RoutesComponent msalInstance={props.msalInstance} />
                                </MsalProvider>
                            </LocalizationProvider>
                        </BrowserRouter>
                    </Fragment>
                </StoreContext.Provider>
            </SnackbarProvider>
            )}

            {/* </AppInsightsErrorBoundary>
            </AppInsightsContext.Provider> */}
        </>
    );
}

export default App;
